// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-bar-color{
    background-color:rgb(87, 219, 146) !important;
}
.card-header-content{
    padding-top: 10% !important;
    padding-left: 4% !important;
    background-color:rgb(115, 166, 61) !important;
}
.divlogin{
    display: flex;
    justify-content: center;
    align-items: center;
    width:100%;
 }
 .container{
    display: flex;
    flex-wrap: wrap;
}
.card{
    min-width: 100px;
}
/* .loginImg{
    background-color: skyblue;
    height: 100vh;
    background-image: url(../appPhotoNew.jpeg);
    background-repeat: no-repeat;
} */
/* .divlogo{
    display: flex;
    justify-content: center;
    align-items: center;
    width:100px;
    height: 100px;
    background-image: url(../applogo.jpg)
} */
.divtable{
    display: flex;
    justify-content: center;
    align-items: center;
    width:50%;
    margin-top:-15vh
}
.cardlogin {
      width:45vh;
      min-height: 45vh;
      max-width:420px !important;
      margin-top:20px;
    }
.cardreview{
        margin-top:-11vh;;
      }
.cardrating{
        width:95%;
        max-width: 800px;
        min-width: 45%;
      }
.cardjobpost{
        width:'100%';
        max-width: 1300px;
        min-width: 45%;
 } 
 .container{
    display: flex;
    flex-wrap: wrap;
}
.signinButton {
    width:40%;
    background-color: #357EDD !important ;
    text-transform: none !important;

}
.signupButton{
    text-transform: none !important;
    width:60% !important;

    }
 .signupText{
    display: block;
    margin-top: 9vh !important;
 }

.tablecell_login {
    display: flex !important;
    justify-content:center !important;
    align-items: center !important;
    border:none !important;
}
.loginSection {
    width: 100%;
    max-width: 350px;
}

.contain-fullscreen-div{
    width:100% !important;
}
.job-post-div{
    align-items: center;
    justify-content: center;
    display:flex;
}
.fab-help-icon{
    margin-left: 90%;
    display:flex;
}
.fab-help-icon-text{
    font-size: 20px;
}
.card-header-title{
color:white;
font-size: 18px;
}
.card-header-subtitle{
    color:white;
    font-size: 13px;
    }
.contain-fullscreen-div{
    width:100% !important;
}

.pt6.pb4{
    width: 70%;
}
/* Copied from Tachyons */
.tc { text-align: center; }

.flex { display: flex; }
.flex-column { flex-direction: column; }
.flex-row { flex-direction: row; }
.items-center { align-items: center; }
.v-mid { vertical-align: middle; }
.justify-center { justify-content: center; }
.mid-gray{
color:#4d4d4e
}
.mt10{margin-top: 90vh}
.image-edit-button-style{
    position:absolute !important;
    top:-37vh !important;
    left:80% !important;

  }
.review_card{
    margin-top:-5% !important;
}

.pagination li{
    display: inline-block;
    padding: 6px;
    border-style: solid;
    border-width: thin;
    /* border-color: rgb(55,123,182); */
    color: rgb(55,123,182);
    font-size: large;
}
.pagination ul{
    display: inline-block;
    /* padding-left: 15px;
    padding-right: 15px; */
}
.pagee{
    /* padding: 10px; */
}
.pagessub{
    /* padding:10;*/
}
.active{
    /* padding: 10; */
    background-color: rgb(55,123,182);
    color: white !important;
    /* border-style: none; */
}
.break-me{
    display: inline ;
}
.previous{
    margin-left: 10px;
    padding: 6px;
}
.next{
    margin-right: 10px;
    padding: 6px;
}
.activeLink{
     /* padding: 10px;
    border-style: none; */
}
.pagination{
    display: flex;
    justify-content: center;
}
.pageLink{
    padding: 6px 8px 6px 8px ;
    border-style: none;
}
.previousLink{
    padding: 6px;
}
.nextLink{
    padding: 6px;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/meetApp.css"],"names":[],"mappings":"AAAA;IACI,6CAA6C;AACjD;AACA;IACI,2BAA2B;IAC3B,2BAA2B;IAC3B,6CAA6C;AACjD;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;CACb;CACA;IACG,aAAa;IACb,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;;;;;GAKG;AACH;;;;;;;GAOG;AACH;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT;AACJ;AACA;MACM,UAAU;MACV,gBAAgB;MAChB,0BAA0B;MAC1B,eAAe;IACjB;AACJ;QACQ,gBAAgB;MAClB;AACN;QACQ,SAAS;QACT,gBAAgB;QAChB,cAAc;MAChB;AACN;QACQ,YAAY;QACZ,iBAAiB;QACjB,cAAc;CACrB;CACA;IACG,aAAa;IACb,eAAe;AACnB;AACA;IACI,SAAS;IACT,qCAAqC;IACrC,+BAA+B;;AAEnC;AACA;IACI,+BAA+B;IAC/B,oBAAoB;;IAEpB;CACH;IACG,cAAc;IACd,0BAA0B;CAC7B;;AAED;IACI,wBAAwB;IACxB,iCAAiC;IACjC,8BAA8B;IAC9B,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;AACA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,eAAe;AACnB;AACA;AACA,WAAW;AACX,eAAe;AACf;AACA;IACI,WAAW;IACX,eAAe;IACf;AACJ;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;AACA,yBAAyB;AACzB,MAAM,kBAAkB,EAAE;;AAE1B,QAAQ,aAAa,EAAE;AACvB,eAAe,sBAAsB,EAAE;AACvC,YAAY,mBAAmB,EAAE;AACjC,gBAAgB,mBAAmB,EAAE;AACrC,SAAS,sBAAsB,EAAE;AACjC,kBAAkB,uBAAuB,EAAE;AAC3C;AACA;AACA;AACA,MAAM,gBAAgB;AACtB;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,mBAAmB;;EAErB;AACF;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,mCAAmC;IACnC,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB;0BACsB;AAC1B;AACA;IACI,mBAAmB;AACvB;AACA;IACI,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,iCAAiC;IACjC,uBAAuB;IACvB,wBAAwB;AAC5B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,YAAY;AAChB;AACA;KACK;yBACoB;AACzB;AACA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB","sourcesContent":[".app-bar-color{\n    background-color:rgb(87, 219, 146) !important;\n}\n.card-header-content{\n    padding-top: 10% !important;\n    padding-left: 4% !important;\n    background-color:rgb(115, 166, 61) !important;\n}\n.divlogin{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width:100%;\n }\n .container{\n    display: flex;\n    flex-wrap: wrap;\n}\n.card{\n    min-width: 100px;\n}\n/* .loginImg{\n    background-color: skyblue;\n    height: 100vh;\n    background-image: url(../appPhotoNew.jpeg);\n    background-repeat: no-repeat;\n} */\n/* .divlogo{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width:100px;\n    height: 100px;\n    background-image: url(../applogo.jpg)\n} */\n.divtable{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width:50%;\n    margin-top:-15vh\n}\n.cardlogin {\n      width:45vh;\n      min-height: 45vh;\n      max-width:420px !important;\n      margin-top:20px;\n    }\n.cardreview{\n        margin-top:-11vh;;\n      }\n.cardrating{\n        width:95%;\n        max-width: 800px;\n        min-width: 45%;\n      }\n.cardjobpost{\n        width:'100%';\n        max-width: 1300px;\n        min-width: 45%;\n } \n .container{\n    display: flex;\n    flex-wrap: wrap;\n}\n.signinButton {\n    width:40%;\n    background-color: #357EDD !important ;\n    text-transform: none !important;\n\n}\n.signupButton{\n    text-transform: none !important;\n    width:60% !important;\n\n    }\n .signupText{\n    display: block;\n    margin-top: 9vh !important;\n }\n\n.tablecell_login {\n    display: flex !important;\n    justify-content:center !important;\n    align-items: center !important;\n    border:none !important;\n}\n.loginSection {\n    width: 100%;\n    max-width: 350px;\n}\n\n.contain-fullscreen-div{\n    width:100% !important;\n}\n.job-post-div{\n    align-items: center;\n    justify-content: center;\n    display:flex;\n}\n.fab-help-icon{\n    margin-left: 90%;\n    display:flex;\n}\n.fab-help-icon-text{\n    font-size: 20px;\n}\n.card-header-title{\ncolor:white;\nfont-size: 18px;\n}\n.card-header-subtitle{\n    color:white;\n    font-size: 13px;\n    }\n.contain-fullscreen-div{\n    width:100% !important;\n}\n\n.pt6.pb4{\n    width: 70%;\n}\n/* Copied from Tachyons */\n.tc { text-align: center; }\n\n.flex { display: flex; }\n.flex-column { flex-direction: column; }\n.flex-row { flex-direction: row; }\n.items-center { align-items: center; }\n.v-mid { vertical-align: middle; }\n.justify-center { justify-content: center; }\n.mid-gray{\ncolor:#4d4d4e\n}\n.mt10{margin-top: 90vh}\n.image-edit-button-style{\n    position:absolute !important;\n    top:-37vh !important;\n    left:80% !important;\n\n  }\n.review_card{\n    margin-top:-5% !important;\n}\n\n.pagination li{\n    display: inline-block;\n    padding: 6px;\n    border-style: solid;\n    border-width: thin;\n    /* border-color: rgb(55,123,182); */\n    color: rgb(55,123,182);\n    font-size: large;\n}\n.pagination ul{\n    display: inline-block;\n    /* padding-left: 15px;\n    padding-right: 15px; */\n}\n.pagee{\n    /* padding: 10px; */\n}\n.pagessub{\n    /* padding:10;*/\n}\n.active{\n    /* padding: 10; */\n    background-color: rgb(55,123,182);\n    color: white !important;\n    /* border-style: none; */\n}\n.break-me{\n    display: inline ;\n}\n.previous{\n    margin-left: 10px;\n    padding: 6px;\n}\n.next{\n    margin-right: 10px;\n    padding: 6px;\n}\n.activeLink{\n     /* padding: 10px;\n    border-style: none; */\n}\n.pagination{\n    display: flex;\n    justify-content: center;\n}\n.pageLink{\n    padding: 6px 8px 6px 8px ;\n    border-style: none;\n}\n.previousLink{\n    padding: 6px;\n}\n.nextLink{\n    padding: 6px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
